window.onload = function() {
    // Define the configuration object (particleConfig) once.
    // This serves as the default config for the BLACK sections (particles-js, particles-extra)
    const particleConfig = {
        "particles": {
            "number": {
                "value": 80,
                "density": {
                    "enable": true,
                    "value_area": 800
                }
            },
            // BLACK SECTION MASK COLOR
            "color": {
                "value": "#181616" // Particle fill is black to mask lines on black background
            },
            "shape": {
                "type": "circle",
                "stroke": {
                    "width": 8,
                    "color": "#ffffff" // White Border
                },
                "polygon": {
                    "nb_sides": 5
                },
                "image": {
                    "src": "img/github.svg",
                    "width": 100,
                    "height": 100
                }
            },
            "opacity": {
                "value": 1, // Default opacity is 1
                "random": false,
                "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 1,
                    "sync": false
                }
            },
            "size": {
                "value": 10,
                "random": true,
                "anim": {
                    "enable": false,
                    "speed": 40,
                    "size_min": 0.1,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": true,
                "distance": 120,
                "color": "#ffffff", // White Line Color (Visible on Black Background)
                "opacity": 1,
                "width": 3
            },
            "move": {
                "enable": true,
                "speed": 3,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": true,
                    "mode": "repulse"
                },
                "onclick": {
                    "enable": true,
                    "mode": "push"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 1
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 40,
                    "duration": 2,
                    "opacity": 1,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200,
                    "duration": 0.8
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true
    };

    // ----------------------------------------------------------------------
    // INITIALIZATION BLOCK 1: Black Sections (Using particleConfig)
    // Wrap initialization calls in a check to prevent the TypeError if the ID is missing.
    // ----------------------------------------------------------------------

    // Apply the effect to the hero section (particles-js)
    if (document.getElementById("particles-js")) {
        particlesJS("particles-js", particleConfig);
    }

    // Apply the effect to the extra black section (particles-extra)
    if (document.getElementById("particles-extra")) {
        particlesJS("particles-extra", particleConfig);
    }
    
    // ----------------------------------------------------------------------
    // INITIALIZATION BLOCK 2: Yellow Section (particles-bg)
    // ----------------------------------------------------------------------
    
    // Create a deep copy of the base configuration
    const bgConfig = JSON.parse(JSON.stringify(particleConfig));

    // ONLY CHANGE OPACITY (as requested)
    bgConfig.particles.opacity.value = 0; 
    
    // ADDED: Safety check for particles-bg
    if (document.getElementById("particles-bg")) {
        particlesJS("particles-bg", bgConfig);
    }
};